import * as React from "react";
import { Coordinates, EllipseCoordinates } from "../../../api/patientScans";

interface OtherOrganMetastasesImageProps {
  metastases: { [key: string]: Coordinates | EllipseCoordinates };
  onPointerMove: (event: React.PointerEvent) => void;
  onPointerLeave: () => void;
  onOrganOrLymphNodeClick: React.MouseEventHandler<SVGSVGElement>;
  onMetastasisClick: React.MouseEventHandler<SVGCircleElement>;
  onContextMenu: React.MouseEventHandler<SVGCircleElement>;
  markerColor: string;
}

const OtherOrganMetastasesImage = React.forwardRef<
  SVGSVGElement,
  OtherOrganMetastasesImageProps
>(
  (
    {
      metastases,
      onOrganOrLymphNodeClick,
      onMetastasisClick,
      onContextMenu,
      onPointerMove,
      onPointerLeave,
      markerColor,
    },
    ref
  ) => (
    <svg
      id="OtherOrganMetastasesImage"
      ref={ref}
      viewBox="0 0 1024 768"
      width="100%"
      height="100%"
      fill="none"
      style={{ maxHeight: "77vh" }}
      onPointerMove={onPointerMove}
      onPointerLeave={onPointerLeave}
      onClick={onOrganOrLymphNodeClick}
    >
      <rect width={1024} height={768} fill="#E5E5E5" />
      <g id="Distant LNs" clipPath="url(#clip0_OtherOrganMetastasesImage)">
        <rect width={1024} height={768} fill="white" />
        <g id="Skeleton blur" opacity={0.5}>
          <g id="Group" filter="url(#filter0_f_OtherOrganMetastasesImage)">
            <g id="Group_2">
              <path
                id="Vector"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M367.523 296.405C367.523 296.405 357.937 314.764 380.418 347.719C402.899 380.673 430.383 485.383 453.078 418.855C475.773 352.326 477.505 311.744 457.953 297.258C449.643 291.101 439.638 293.863 430.882 299.074C417.242 307.186 399.787 306.983 386.365 298.556C378.485 293.608 370.831 291.003 367.523 296.405Z"
                fill="#B1B1B1"
                fillOpacity={0.34}
              />
            </g>
            <g id="Group_3">
              <path
                id="Vector_2"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M656.477 296.405C656.477 296.405 666.063 314.764 643.582 347.719C621.101 380.673 593.617 485.383 570.922 418.855C548.227 352.326 546.494 311.744 566.046 297.258C574.357 291.101 584.362 293.863 593.118 299.074C606.758 307.186 624.213 306.983 637.635 298.556C645.515 293.608 653.169 291.003 656.477 296.405Z"
                fill="#B1B1B1"
                fillOpacity={0.34}
              />
            </g>
            <g id="Group_4">
              <path
                id="Vector_3"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M512.395 179.833C529.151 179.833 570.638 129.573 574.962 108C584.945 117.368 563.834 165.094 563.834 179.833C563.834 208.171 540.785 231.178 512.395 231.178V179.833Z"
                fill="#B1B1B1"
                fillOpacity={0.34}
              />
            </g>
            <g id="Group_5">
              <path
                id="Vector_4"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M511.259 179.833C494.503 179.833 453.016 129.573 448.692 108C438.71 117.368 459.821 165.094 459.821 179.833C459.821 208.171 482.869 231.178 511.259 231.178V179.833Z"
                fill="#B1B1B1"
                fillOpacity={0.34}
              />
            </g>
            <g id="Group_6">
              <path
                id="Vector_5"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M528.656 112.286H497.148C494.336 221.956 500.619 331.822 499.974 441.133C499.451 529.713 490.849 617.929 497.148 705.381H528.656C532.878 618.887 526.207 531.245 525.529 442.785C524.693 333.657 529.17 223.284 528.656 112.286Z"
                fill="#B1B1B1"
                fillOpacity={0.34}
              />
            </g>
            <g id="Group_7">
              <path
                id="Vector_6"
                d="M492.587 380.56C492.587 380.56 375.249 412.301 403.967 454.339"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_8">
              <path
                id="Vector_7"
                d="M532.692 380.56C532.692 380.56 650.029 412.301 621.312 454.339"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_9">
              <path
                id="Vector_8"
                d="M492.589 358.409C492.589 358.409 375.251 384.279 403.969 426.317"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_10">
              <path
                id="Vector_9"
                d="M532.69 358.409C532.69 358.409 650.028 384.279 621.31 426.317"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_11">
              <path
                id="Vector_10"
                d="M492.589 339.951C492.589 339.951 375.251 356.476 403.97 398.516"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_12">
              <path
                id="Vector_11"
                d="M532.69 339.951C532.69 339.951 650.028 356.476 621.309 398.516"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_13">
              <path
                id="Vector_12"
                d="M496.273 318.138C496.273 318.138 376.003 317.628 403.969 369.285"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_14">
              <path
                id="Vector_13"
                d="M529.007 318.138C529.007 318.138 649.277 317.628 621.311 369.285"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_15">
              <path
                id="Vector_14"
                d="M499.779 300.737C499.779 300.737 373.754 290.678 403.967 348.582"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_16">
              <path
                id="Vector_15"
                d="M525.5 300.737C525.5 300.737 651.526 290.678 621.313 348.582"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_17">
              <path
                id="Vector_16"
                d="M496.273 263.792C496.273 263.792 445.608 260.614 428.126 310.347"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_18">
              <path
                id="Vector_17"
                d="M529.007 263.792C529.007 263.792 579.671 260.614 597.154 310.347"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_19">
              <path
                id="Vector_18"
                d="M496.269 282.622C496.269 282.622 423.662 275.861 403.966 328.59"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_20">
              <path
                id="Vector_19"
                d="M529.009 282.622C529.009 282.622 601.617 275.861 621.313 328.59"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_21">
              <path
                id="Vector_20"
                d="M492.713 231.18L534.058 231.119"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_22">
              <path
                id="Vector_21"
                d="M492.713 243.033L534.058 242.971"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_23">
              <path
                id="Vector_22"
                d="M488.668 254.928L538.093 254.855"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_24">
              <path
                id="Vector_23"
                d="M486.544 267.471L540.225 267.391"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_25">
              <path
                id="Vector_24"
                d="M486.544 282.187L540.225 282.107"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_26">
              <path
                id="Vector_25"
                d="M486.544 301.595L540.225 301.515"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_27">
              <path
                id="Vector_26"
                d="M486.544 322.045L540.225 321.966"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_28">
              <path
                id="Vector_27"
                d="M486.544 342.753L540.225 342.673"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_29">
              <path
                id="Vector_28"
                d="M486.544 363.071L540.225 362.991"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_30">
              <path
                id="Vector_29"
                d="M486.544 386.19C504.138 389.749 522.054 389.446 540.225 386.11"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_31">
              <path
                id="Vector_30"
                d="M486.544 402.342C504.25 406.294 522.152 406.091 540.225 402.262"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_32">
              <path
                id="Vector_31"
                d="M486.544 423.702C504.348 427.524 522.237 427.675 540.225 423.622"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_33">
              <path
                id="Vector_32"
                d="M486.544 449.035C504.261 452.856 522.154 452.837 540.225 448.955"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_34">
              <path
                id="Vector_33"
                d="M486.544 473.064L540.225 472.984"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_35">
              <path
                id="Vector_34"
                d="M486.544 496.771L540.225 496.692"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_36">
              <path
                id="Vector_35"
                d="M486.544 518.778L540.225 518.698"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_37">
              <path
                id="Vector_36"
                d="M486.544 538.578L540.225 538.498"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_38">
              <path
                id="Vector_37"
                d="M483.634 561.436L543.135 561.347"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_39">
              <path
                id="Vector_38"
                d="M483.634 584.553L543.135 584.464"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_40">
              <path
                id="Vector_39"
                d="M483.634 602.006C503.241 607.727 523.056 608.165 543.135 601.917"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_41">
              <path
                id="Vector_40"
                d="M483.634 622.976C503.241 628.698 523.056 629.136 543.135 622.888"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_42">
              <path
                id="Vector_41"
                d="M483.634 642.84C503.241 648.562 523.056 649 543.135 642.752"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_43">
              <path
                id="Vector_42"
                d="M483.634 661.138C503.241 666.86 523.056 667.298 543.135 661.05"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_44">
              <path
                id="Vector_43"
                d="M493.686 682.759C506.67 686.52 519.792 686.808 533.089 682.701"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
            <g id="Group_45">
              <path
                id="Vector_44"
                d="M504.31 703.953C510.293 705.686 516.339 705.819 522.465 703.926"
                stroke="#B1B1B1"
                strokeOpacity={0.34}
                strokeWidth={13}
                strokeMiterlimit={7.07317}
                strokeLinecap="round"
              />
            </g>
          </g>
          <g id="Group 20" filter="url(#filter1_f_OtherOrganMetastasesImage)">
            <path
              id="Vector_45"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M425.034 631.966C425.034 631.966 440.055 655.352 423.941 665.205C423.941 665.205 399.913 653.896 393.452 681.754C390.483 694.54 406.045 694.217 415.307 747.668L418.564 766.564L446.084 768C446.084 768 430.386 734.295 435.287 712.607C440.187 690.919 438.841 680.601 457.225 678.254C457.225 678.254 445.461 644.954 425.034 631.966Z"
              fill="url(#paint0_linear_OtherOrganMetastasesImage)"
              fillOpacity={0.34}
            />
            <path
              id="Vector_46"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M598.702 631.966C598.702 631.966 583.85 655.352 599.782 665.205C599.782 665.205 623.538 653.896 629.926 681.754C632.862 694.54 617.476 694.217 608.318 747.668L605.098 766.564L577.89 768C577.89 768 593.41 734.295 588.564 712.607C583.72 690.919 585.051 680.601 566.875 678.254C566.875 678.254 578.506 644.954 598.702 631.966Z"
              fill="url(#paint1_linear_OtherOrganMetastasesImage)"
              fillOpacity={0.34}
            />
            <g id="Group_46">
              <path
                id="Vector_47"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M467.962 661.966C467.962 661.966 484.998 676.384 500.188 671.316C509.937 668.065 510.379 691.751 496.944 700.534C483.509 709.318 478.85 704.23 469.925 701.584C450.588 695.85 467.962 661.966 467.962 661.966Z"
                fill="#B1B1B1"
                fillOpacity={0.14}
              />
            </g>
            <g id="Group_47">
              <path
                id="Vector_48"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M555.075 661.966C555.075 661.966 538.038 676.383 522.849 671.315C513.099 668.064 512.657 691.75 526.092 700.534C539.528 709.318 544.186 704.229 553.111 701.584C572.449 695.849 555.075 661.966 555.075 661.966Z"
                fill="#B1B1B1"
                fillOpacity={0.14}
              />
            </g>
            <g id="Group_48">
              <path
                id="Vector_49"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M430.376 649.909C430.376 649.909 421.938 631.069 407.221 617.015C392.505 602.961 407.738 545.149 456.85 566.472C505.96 587.816 476.042 620.447 469.048 635.127C462.055 649.808 467.005 645.466 469.47 659.419C471.935 673.373 459.417 694.231 489.775 704.59C489.775 704.59 464.629 716 456.85 687.306C449.069 658.612 440.92 658.208 430.376 649.909Z"
                fill="#B1B1B1"
                fillOpacity={0.34}
              />
            </g>
            <g id="Group_49">
              <path
                id="Vector_50"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M592.66 649.909C592.66 649.909 601.097 631.069 615.815 617.015C630.531 602.961 615.298 545.149 566.185 566.472C517.075 587.816 546.994 620.447 553.987 635.128C560.98 649.808 556.03 645.466 553.566 659.419C551.101 673.373 563.618 694.231 533.26 704.59C533.26 704.59 558.406 716 566.185 687.306C573.967 658.612 582.115 658.208 592.66 649.909Z"
                fill="#B1B1B1"
                fillOpacity={0.34}
              />
            </g>
          </g>
          <g id="Group 18" filter="url(#filter2_f_OtherOrganMetastasesImage)">
            <g id="Group 66">
              <path
                id="Union"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M511.687 490.22C510.533 489.313 509.078 488.772 507.496 488.772C503.748 488.772 500.709 491.81 500.709 495.559C500.709 526.976 498.018 545.997 492.876 559.912C487.809 573.623 480.175 582.922 468.892 594.692C466.142 597.56 463.379 600.566 460.641 603.734C460.122 604.18 459.666 604.707 459.296 605.306C447.873 618.793 437.012 635.182 429.585 656.243C420.089 683.169 416.38 717.23 423.642 761.93C424.243 765.63 427.73 768.142 431.429 767.541C435.129 766.94 437.641 763.453 437.04 759.753C430.081 716.915 433.767 685.199 442.386 660.757C446.284 649.704 451.227 640.036 456.761 631.416C457.498 637.425 458.925 642.919 460.547 646.679C462.031 650.121 466.024 651.708 469.466 650.224C472.908 648.74 474.495 644.746 473.011 641.304C471.878 638.675 470.551 633.675 470.028 627.812C469.553 622.494 469.792 617.031 471.077 612.418C473.588 609.521 476.135 606.751 478.69 604.085C490.336 591.938 499.554 581.002 505.608 564.617C508.4 557.062 510.476 548.47 511.896 538.205C513.291 547.071 515.223 554.926 517.728 562.071C523.702 579.113 532.775 591.662 544.684 604.085C546.984 606.485 549.279 608.97 551.546 611.556C552.923 616.387 553.192 622.217 552.727 627.858C552.24 633.765 551.006 638.812 549.944 641.482C548.557 644.964 550.257 648.911 553.74 650.298C557.222 651.684 561.169 649.984 562.555 646.502C564.098 642.626 565.452 636.879 566.101 630.624C571.843 639.443 576.971 649.364 580.988 660.757C589.608 685.199 593.293 716.915 586.334 759.753C585.733 763.453 588.245 766.94 591.945 767.541C595.645 768.142 599.132 765.63 599.733 761.93C606.994 717.23 603.285 683.169 593.79 656.243C584.297 629.326 569.196 610.04 554.483 594.692C543.463 583.197 535.684 572.261 530.537 557.581C525.336 542.743 522.665 523.626 522.665 495.559C522.665 491.81 519.627 488.772 515.878 488.772C514.296 488.772 512.841 489.313 511.687 490.22Z"
                fill="url(#paint2_linear_OtherOrganMetastasesImage)"
                fillOpacity={0.34}
              />
            </g>
          </g>
        </g>
        <g id="Subtract" filter="url(#filter3_f_OtherOrganMetastasesImage)">
          <path
            d="M518.36 398.631C517.263 407.606 516.652 416.491 517.095 424.693L505.105 424.693C505.544 416.491 504.939 407.606 503.852 398.631L518.36 398.631Z"
            fill="url(#paint3_radial_OtherOrganMetastasesImage)"
            fillOpacity={0.3}
          />
          <path
            d="M518.36 398.631C517.263 407.606 516.652 416.491 517.095 424.693L505.105 424.693C505.544 416.491 504.939 407.606 503.852 398.631L518.36 398.631Z"
            fill="url(#paint4_linear_OtherOrganMetastasesImage)"
          />
          <path
            d="M493.131 398.631C493.056 398.631 492.981 398.629 492.906 398.626L492.9 398.626C492.977 398.629 493.054 398.631 493.131 398.631Z"
            fill="url(#paint5_radial_OtherOrganMetastasesImage)"
            fillOpacity={0.3}
          />
          <path
            d="M493.131 398.631C493.056 398.631 492.981 398.629 492.906 398.626L492.9 398.626C492.977 398.629 493.054 398.631 493.131 398.631Z"
            fill="url(#paint6_linear_OtherOrganMetastasesImage)"
          />
          <path
            d="M492.879 398.625L492.848 398.624L492.811 398.622C492.834 398.623 492.856 398.624 492.879 398.625Z"
            fill="url(#paint7_radial_OtherOrganMetastasesImage)"
            fillOpacity={0.3}
          />
          <path
            d="M492.879 398.625L492.848 398.624L492.811 398.622C492.834 398.623 492.856 398.624 492.879 398.625Z"
            fill="url(#paint8_linear_OtherOrganMetastasesImage)"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M760 400.64C724.467 358.349 691.217 315.951 691.217 315.951C660.215 270.437 648.302 268.591 624.048 264.831C614.309 263.321 602.579 261.502 586.823 256.423C586.17 256.213 585.53 255.994 584.903 255.767V282.022C584.903 285.266 582.27 287.895 579.021 287.895H541.283C538.034 287.895 535.401 285.266 535.401 282.022V245.17C535.401 241.926 538.034 239.296 541.283 239.296H563.436L563.365 239.184L563.304 239.089L563.26 239.019C562.695 239.199 562.094 239.296 561.471 239.296H523.732C520.484 239.296 517.85 236.666 517.85 233.422V195.67C517.85 192.426 520.484 189.796 523.732 189.796H558.483C559.466 185.374 560.513 181.944 561.131 180.072C561.284 179.607 561.931 177.732 562.593 175.824C568.552 175.047 570.823 169.253 573.901 161.4C574.783 159.149 575.732 156.728 576.853 154.208C585.973 133.706 579.802 131.333 571.55 129.214C571.501 129.201 571.451 129.188 571.401 129.176L571.347 129.163L571.301 129.152L571.255 129.142L571.207 129.131L571.177 129.124C573.035 122.483 574.038 115.411 574.038 108.077C574.038 69.4955 546.282 44 512.094 44C477.906 44 450.15 69.4955 450.15 108.077C450.15 115.67 451.224 122.981 453.212 129.827C446.183 131.932 441.879 135.615 450.15 154.208C451.27 156.728 452.219 159.148 453.101 161.399C456.184 169.264 458.457 175.064 464.436 175.828C465.153 177.937 465.898 180.141 466.129 180.867C466.756 182.839 467.662 185.941 468.519 189.796H499.368C502.616 189.796 505.249 192.426 505.249 195.67V233.422C505.249 236.666 502.616 239.296 499.368 239.296H463.567L482.717 239.296C485.966 239.296 488.599 241.926 488.599 245.17V282.022C488.599 285.266 485.966 287.895 482.717 287.895H444.979C441.73 287.895 439.097 285.266 439.097 282.022V256.769C423.884 261.586 412.469 263.355 402.954 264.831C378.7 268.591 366.787 270.437 335.784 315.951C335.784 315.951 300.026 357.893 264 397.119V491.089L362.308 399.61C361.103 398.535 360.344 396.971 360.344 395.229V357.477C360.344 354.233 362.977 351.604 366.226 351.604H403.064C406.313 351.604 408.946 354.233 408.946 357.477V395.229C408.946 398.473 406.313 401.103 403.064 401.103H382.857C395.211 441.807 413.14 502.15 393.5 566.5C373.031 633.563 384.733 756.356 384.875 761.459C384.903 762.46 384.923 763.186 384.777 763.995C384.12 767.647 472.532 769.42 513.501 766.634C554.471 769.42 642.882 766.867 642.224 763.215C642.078 762.405 642.099 761.7 642.127 760.733C642.269 755.808 649.466 633.555 629 566.5C609.36 502.15 631.791 441.807 644.145 401.103H620.036C616.787 401.103 614.154 398.473 614.154 395.229V357.477C614.154 354.233 616.787 351.604 620.036 351.604H657.774C661.023 351.604 663.656 354.233 663.656 357.477V395.229C663.656 396.293 663.373 397.29 662.878 398.15L760 490.152V400.64ZM513.061 55.4019C512.552 55.0007 511.899 54.7735 511.201 54.8019C482.444 56.1319 457.303 79.5084 457.55 108.109C463.594 165.185 477.326 164.038 499.297 162.204C502.45 161.941 505.772 161.663 509.266 161.542C510.368 161.511 511.929 159.536 511.993 158.289C512.515 160.351 514.854 161.522 515.738 161.549C519.191 161.674 522.463 161.949 525.557 162.209C547.357 164.04 560.381 165.134 566.45 108.099C566.697 79.6324 543.656 56.3399 514.953 54.8033C514.266 54.7676 513.594 54.9839 513.061 55.4019ZM482.494 464.981C484.079 465.057 485.665 465.157 487.249 465.278L487.249 456.77C483.84 457.159 480.056 456.778 476.022 456.373C467.476 455.513 457.808 454.541 448.208 460.532C400.917 490.04 392.941 452.426 415.996 376.527C433.084 320.274 463.144 300.52 477.557 294.063C479.855 293.048 482.47 293.038 484.776 294.035C487.082 295.032 488.871 296.949 489.712 299.325C491.922 305.603 494.389 316.113 495.248 332.856L527.04 332.856C527.906 316.114 530.396 305.603 532.624 299.325C533.474 296.95 535.278 295.032 537.604 294.035C539.93 293.039 542.569 293.048 544.888 294.063C559.428 300.52 589.754 320.275 606.993 376.528C630.252 452.426 622.206 490.04 574.496 460.532C564.811 454.541 555.057 455.513 546.435 456.373L546.433 456.373C543.001 456.715 539.748 457.039 536.751 456.899L536.751 430.566V466.519C536.751 469.763 534.117 472.392 530.869 472.392H527.666C541.726 476.073 553.364 480.241 559.997 482.796C561.454 483.369 562.523 484.639 562.837 486.173C563.154 487.706 562.671 489.296 561.557 490.396C556.097 495.671 544.856 503.858 523.964 509.598C512.662 512.702 496.996 520.033 474.342 537.183C454.92 551.886 429.729 560.482 425.554 546.417C407.512 485.645 432.304 462.57 482.494 464.981ZM530.869 575.127C534.117 575.127 536.751 577.756 536.751 581V621C536.751 624.244 534.117 626.873 530.869 626.873H493.131C489.882 626.873 487.249 624.244 487.249 621V581C487.249 577.756 489.882 575.127 493.131 575.127H530.869Z"
            fill="url(#paint9_radial_OtherOrganMetastasesImage)"
            fillOpacity={0.3}
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M760 400.64C724.467 358.349 691.217 315.951 691.217 315.951C660.215 270.437 648.302 268.591 624.048 264.831C614.309 263.321 602.579 261.502 586.823 256.423C586.17 256.213 585.53 255.994 584.903 255.767V282.022C584.903 285.266 582.27 287.895 579.021 287.895H541.283C538.034 287.895 535.401 285.266 535.401 282.022V245.17C535.401 241.926 538.034 239.296 541.283 239.296H563.436L563.365 239.184L563.304 239.089L563.26 239.019C562.695 239.199 562.094 239.296 561.471 239.296H523.732C520.484 239.296 517.85 236.666 517.85 233.422V195.67C517.85 192.426 520.484 189.796 523.732 189.796H558.483C559.466 185.374 560.513 181.944 561.131 180.072C561.284 179.607 561.931 177.732 562.593 175.824C568.552 175.047 570.823 169.253 573.901 161.4C574.783 159.149 575.732 156.728 576.853 154.208C585.973 133.706 579.802 131.333 571.55 129.214C571.501 129.201 571.451 129.188 571.401 129.176L571.347 129.163L571.301 129.152L571.255 129.142L571.207 129.131L571.177 129.124C573.035 122.483 574.038 115.411 574.038 108.077C574.038 69.4955 546.282 44 512.094 44C477.906 44 450.15 69.4955 450.15 108.077C450.15 115.67 451.224 122.981 453.212 129.827C446.183 131.932 441.879 135.615 450.15 154.208C451.27 156.728 452.219 159.148 453.101 161.399C456.184 169.264 458.457 175.064 464.436 175.828C465.153 177.937 465.898 180.141 466.129 180.867C466.756 182.839 467.662 185.941 468.519 189.796H499.368C502.616 189.796 505.249 192.426 505.249 195.67V233.422C505.249 236.666 502.616 239.296 499.368 239.296H463.567L482.717 239.296C485.966 239.296 488.599 241.926 488.599 245.17V282.022C488.599 285.266 485.966 287.895 482.717 287.895H444.979C441.73 287.895 439.097 285.266 439.097 282.022V256.769C423.884 261.586 412.469 263.355 402.954 264.831C378.7 268.591 366.787 270.437 335.784 315.951C335.784 315.951 300.026 357.893 264 397.119V491.089L362.308 399.61C361.103 398.535 360.344 396.971 360.344 395.229V357.477C360.344 354.233 362.977 351.604 366.226 351.604H403.064C406.313 351.604 408.946 354.233 408.946 357.477V395.229C408.946 398.473 406.313 401.103 403.064 401.103H382.857C395.211 441.807 413.14 502.15 393.5 566.5C373.031 633.563 384.733 756.356 384.875 761.459C384.903 762.46 384.923 763.186 384.777 763.995C384.12 767.647 472.532 769.42 513.501 766.634C554.471 769.42 642.882 766.867 642.224 763.215C642.078 762.405 642.099 761.7 642.127 760.733C642.269 755.808 649.466 633.555 629 566.5C609.36 502.15 631.791 441.807 644.145 401.103H620.036C616.787 401.103 614.154 398.473 614.154 395.229V357.477C614.154 354.233 616.787 351.604 620.036 351.604H657.774C661.023 351.604 663.656 354.233 663.656 357.477V395.229C663.656 396.293 663.373 397.29 662.878 398.15L760 490.152V400.64ZM513.061 55.4019C512.552 55.0007 511.899 54.7735 511.201 54.8019C482.444 56.1319 457.303 79.5084 457.55 108.109C463.594 165.185 477.326 164.038 499.297 162.204C502.45 161.941 505.772 161.663 509.266 161.542C510.368 161.511 511.929 159.536 511.993 158.289C512.515 160.351 514.854 161.522 515.738 161.549C519.191 161.674 522.463 161.949 525.557 162.209C547.357 164.04 560.381 165.134 566.45 108.099C566.697 79.6324 543.656 56.3399 514.953 54.8033C514.266 54.7676 513.594 54.9839 513.061 55.4019ZM482.494 464.981C484.079 465.057 485.665 465.157 487.249 465.278L487.249 456.77C483.84 457.159 480.056 456.778 476.022 456.373C467.476 455.513 457.808 454.541 448.208 460.532C400.917 490.04 392.941 452.426 415.996 376.527C433.084 320.274 463.144 300.52 477.557 294.063C479.855 293.048 482.47 293.038 484.776 294.035C487.082 295.032 488.871 296.949 489.712 299.325C491.922 305.603 494.389 316.113 495.248 332.856L527.04 332.856C527.906 316.114 530.396 305.603 532.624 299.325C533.474 296.95 535.278 295.032 537.604 294.035C539.93 293.039 542.569 293.048 544.888 294.063C559.428 300.52 589.754 320.275 606.993 376.528C630.252 452.426 622.206 490.04 574.496 460.532C564.811 454.541 555.057 455.513 546.435 456.373L546.433 456.373C543.001 456.715 539.748 457.039 536.751 456.899L536.751 430.566V466.519C536.751 469.763 534.117 472.392 530.869 472.392H527.666C541.726 476.073 553.364 480.241 559.997 482.796C561.454 483.369 562.523 484.639 562.837 486.173C563.154 487.706 562.671 489.296 561.557 490.396C556.097 495.671 544.856 503.858 523.964 509.598C512.662 512.702 496.996 520.033 474.342 537.183C454.92 551.886 429.729 560.482 425.554 546.417C407.512 485.645 432.304 462.57 482.494 464.981ZM530.869 575.127C534.117 575.127 536.751 577.756 536.751 581V621C536.751 624.244 534.117 626.873 530.869 626.873H493.131C489.882 626.873 487.249 624.244 487.249 621V581C487.249 577.756 489.882 575.127 493.131 575.127H530.869Z"
            fill="url(#paint10_linear_OtherOrganMetastasesImage)"
          />
        </g>
        <g
          id="KL"
          opacity={0.78}
          filter="url(#filter4_f_OtherOrganMetastasesImage)"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M569.042 544.413C569.042 544.413 602.36 561.759 589.794 592.048C577.228 622.342 549.504 603.331 555.106 585.593C559.404 571.98 540.761 540.321 569.042 544.413Z"
            fill="#BEBEBE"
          />
        </g>
        <g
          id="KR"
          opacity={0.78}
          filter="url(#filter5_f_OtherOrganMetastasesImage)"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M455 544.413C455 544.413 421.682 561.759 434.248 592.048C446.814 622.342 474.538 603.331 468.936 585.593C464.638 571.98 483.281 540.321 455 544.413Z"
            fill="#BEBEBE"
          />
        </g>
        <g id="Group 77">
          <path
            id="Adrenal-Gland-Right"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M468.547 541.955C457.319 533.789 428.991 553.2 445.879 563.504C470.486 578.513 467.572 578.535 472.835 563.796C475.808 555.472 475.699 547.601 468.547 541.955Z"
            fill="white"
          />
          <path
            id="Adrenal-Gland-Left"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M556.437 541.955C567.664 533.789 595.993 553.2 579.105 563.504C554.498 578.513 557.412 578.535 552.149 563.796C549.176 555.472 549.285 547.601 556.437 541.955Z"
            fill="white"
          />
          <g id="CR">
            <g
              id="Rectangle 38"
              filter="url(#filter6_d_OtherOrganMetastasesImage)"
            >
              <rect
                x={456.753}
                y={190.052}
                width={48.5095}
                height={49.4772}
                rx={5.75168}
                fill="white"
              />
            </g>
            <path
              id="CR_2"
              d="M470.888 213.879C470.888 212.774 471.137 211.783 471.635 210.906C472.133 210.018 472.81 209.325 473.666 208.826C474.532 208.328 475.491 208.079 476.541 208.079C477.776 208.079 478.854 208.377 479.774 208.973C480.695 209.568 481.366 210.413 481.789 211.507H480.018C479.704 210.825 479.249 210.299 478.653 209.931C478.068 209.563 477.364 209.379 476.541 209.379C475.751 209.379 475.041 209.563 474.413 209.931C473.785 210.299 473.292 210.825 472.935 211.507C472.577 212.178 472.399 212.969 472.399 213.879C472.399 214.778 472.577 215.568 472.935 216.251C473.292 216.922 473.785 217.442 474.413 217.81C475.041 218.179 475.751 218.363 476.541 218.363C477.364 218.363 478.068 218.184 478.653 217.827C479.249 217.458 479.704 216.933 480.018 216.251H481.789C481.366 217.334 480.695 218.173 479.774 218.769C478.854 219.354 477.776 219.646 476.541 219.646C475.491 219.646 474.532 219.402 473.666 218.915C472.81 218.417 472.133 217.729 471.635 216.852C471.137 215.975 470.888 214.984 470.888 213.879ZM489.952 219.549L487.255 214.919H485.468V219.549H483.989V208.225H487.645C488.5 208.225 489.22 208.372 489.805 208.664C490.401 208.956 490.845 209.352 491.137 209.85C491.43 210.348 491.576 210.917 491.576 211.556C491.576 212.336 491.349 213.023 490.894 213.619C490.45 214.215 489.778 214.61 488.879 214.805L491.722 219.549H489.952ZM485.468 213.733H487.645C488.446 213.733 489.047 213.538 489.448 213.148C489.849 212.747 490.049 212.216 490.049 211.556C490.049 210.884 489.849 210.364 489.448 209.996C489.058 209.628 488.457 209.444 487.645 209.444H485.468V213.733Z"
              fill="#686868"
            />
          </g>
          <g id="CL">
            <g
              id="Rectangle 39"
              filter="url(#filter7_d_OtherOrganMetastasesImage)"
            >
              <rect
                width={49.4079}
                height={49.4772}
                rx={5.75168}
                transform="matrix(-1 0 0 1 567.247 190.052)"
                fill="white"
              />
            </g>
            <path
              id="CL_2"
              d="M532.778 213.879C532.778 212.774 533.027 211.783 533.525 210.906C534.024 210.018 534.701 209.325 535.556 208.826C536.423 208.328 537.381 208.079 538.432 208.079C539.666 208.079 540.744 208.377 541.665 208.973C542.585 209.568 543.257 210.413 543.679 211.507H541.908C541.594 210.825 541.139 210.299 540.544 209.931C539.959 209.563 539.255 209.379 538.432 209.379C537.641 209.379 536.932 209.563 536.304 209.931C535.675 210.299 535.183 210.825 534.825 211.507C534.468 212.178 534.289 212.969 534.289 213.879C534.289 214.778 534.468 215.568 534.825 216.251C535.183 216.922 535.675 217.442 536.304 217.81C536.932 218.179 537.641 218.363 538.432 218.363C539.255 218.363 539.959 218.184 540.544 217.827C541.139 217.458 541.594 216.933 541.908 216.251H543.679C543.257 217.334 542.585 218.173 541.665 218.769C540.744 219.354 539.666 219.646 538.432 219.646C537.381 219.646 536.423 219.402 535.556 218.915C534.701 218.417 534.024 217.729 533.525 216.852C533.027 215.975 532.778 214.984 532.778 213.879ZM547.358 218.346H551.322V219.549H545.88V208.225H547.358V218.346Z"
              fill="#686868"
            />
          </g>
          <g id="SCR">
            <g
              id="Rectangle 40"
              filter="url(#filter8_d_OtherOrganMetastasesImage)"
            >
              <rect
                x={439.235}
                y={239.53}
                width={49.4079}
                height={48.5776}
                rx={5.75168}
                fill="white"
              />
            </g>
            <path
              id="SCR_2"
              d="M452.998 268.691C452.25 268.691 451.579 268.561 450.983 268.301C450.398 268.03 449.938 267.662 449.602 267.196C449.267 266.719 449.093 266.172 449.083 265.555H450.658C450.713 266.086 450.929 266.535 451.308 266.904C451.698 267.261 452.261 267.44 452.998 267.44C453.702 267.44 454.254 267.266 454.655 266.92C455.066 266.562 455.272 266.107 455.272 265.555C455.272 265.122 455.153 264.77 454.915 264.499C454.676 264.228 454.379 264.023 454.021 263.882C453.664 263.741 453.182 263.589 452.575 263.427C451.828 263.232 451.227 263.037 450.772 262.842C450.328 262.647 449.944 262.344 449.619 261.932C449.305 261.51 449.148 260.947 449.148 260.243C449.148 259.625 449.305 259.079 449.619 258.602C449.933 258.125 450.371 257.757 450.935 257.497C451.509 257.237 452.164 257.107 452.9 257.107C453.962 257.107 454.828 257.373 455.5 257.903C456.182 258.434 456.566 259.138 456.653 260.015H455.028C454.974 259.582 454.747 259.203 454.346 258.878C453.945 258.542 453.415 258.375 452.754 258.375C452.137 258.375 451.633 258.537 451.243 258.862C450.853 259.176 450.658 259.62 450.658 260.194C450.658 260.606 450.772 260.941 451 261.201C451.238 261.461 451.525 261.662 451.861 261.802C452.207 261.932 452.689 262.084 453.306 262.257C454.054 262.463 454.655 262.669 455.11 262.875C455.565 263.07 455.954 263.378 456.279 263.801C456.604 264.212 456.767 264.775 456.767 265.49C456.767 266.042 456.621 266.562 456.328 267.05C456.036 267.537 455.602 267.932 455.028 268.236C454.454 268.539 453.778 268.691 452.998 268.691ZM458.39 262.907C458.39 261.802 458.639 260.811 459.137 259.934C459.635 259.046 460.312 258.353 461.168 257.855C462.034 257.356 462.993 257.107 464.043 257.107C465.278 257.107 466.356 257.405 467.276 258.001C468.197 258.597 468.868 259.441 469.291 260.535H467.52C467.206 259.853 466.751 259.328 466.155 258.959C465.571 258.591 464.867 258.407 464.043 258.407C463.253 258.407 462.543 258.591 461.915 258.959C461.287 259.328 460.794 259.853 460.437 260.535C460.079 261.207 459.901 261.997 459.901 262.907C459.901 263.806 460.079 264.597 460.437 265.279C460.794 265.95 461.287 266.47 461.915 266.839C462.543 267.207 463.253 267.391 464.043 267.391C464.867 267.391 465.571 267.212 466.155 266.855C466.751 266.487 467.206 265.961 467.52 265.279H469.291C468.868 266.362 468.197 267.201 467.276 267.797C466.356 268.382 465.278 268.674 464.043 268.674C462.993 268.674 462.034 268.431 461.168 267.943C460.312 267.445 459.635 266.757 459.137 265.88C458.639 265.003 458.39 264.012 458.39 262.907ZM477.454 268.577L474.757 263.947H472.97V268.577H471.491V257.254H475.147C476.002 257.254 476.723 257.4 477.307 257.692C477.903 257.985 478.347 258.38 478.64 258.878C478.932 259.376 479.078 259.945 479.078 260.584C479.078 261.364 478.851 262.051 478.396 262.647C477.952 263.243 477.28 263.638 476.381 263.833L479.224 268.577H477.454ZM472.97 262.761H475.147C475.948 262.761 476.549 262.566 476.95 262.176C477.351 261.775 477.551 261.245 477.551 260.584C477.551 259.912 477.351 259.393 476.95 259.024C476.56 258.656 475.959 258.472 475.147 258.472H472.97V262.761Z"
              fill="#686868"
            />
          </g>
          <g id="SCL">
            <g
              id="Rectangle 41"
              filter="url(#filter9_d_OtherOrganMetastasesImage)"
            >
              <rect
                width={49.4079}
                height={48.5776}
                rx={5.75168}
                transform="matrix(-1 0 0 1 584.765 239.53)"
                fill="white"
              />
            </g>
            <path
              id="SCL_2"
              d="M549.38 268.691C548.632 268.691 547.961 268.561 547.365 268.301C546.78 268.03 546.32 267.662 545.984 267.196C545.649 266.719 545.475 266.172 545.464 265.555H547.04C547.094 266.086 547.311 266.535 547.69 266.904C548.08 267.261 548.643 267.44 549.38 267.44C550.084 267.44 550.636 267.266 551.037 266.92C551.448 266.562 551.654 266.107 551.654 265.555C551.654 265.122 551.535 264.77 551.297 264.499C551.058 264.228 550.761 264.023 550.403 263.882C550.046 263.741 549.564 263.589 548.957 263.427C548.21 263.232 547.609 263.037 547.154 262.842C546.71 262.647 546.325 262.344 546.001 261.932C545.686 261.51 545.529 260.947 545.529 260.243C545.529 259.625 545.686 259.078 546.001 258.602C546.315 258.125 546.753 257.757 547.316 257.497C547.89 257.237 548.546 257.107 549.282 257.107C550.344 257.107 551.21 257.373 551.881 257.903C552.564 258.434 552.948 259.138 553.035 260.015H551.41C551.356 259.582 551.129 259.203 550.728 258.878C550.327 258.542 549.797 258.375 549.136 258.375C548.519 258.375 548.015 258.537 547.625 258.862C547.235 259.176 547.04 259.62 547.04 260.194C547.04 260.606 547.154 260.941 547.381 261.201C547.62 261.461 547.907 261.662 548.242 261.802C548.589 261.932 549.071 262.084 549.688 262.257C550.436 262.463 551.037 262.669 551.492 262.875C551.946 263.07 552.336 263.378 552.661 263.801C552.986 264.212 553.149 264.775 553.149 265.49C553.149 266.042 553.002 266.562 552.71 267.05C552.418 267.537 551.984 267.932 551.41 268.236C550.836 268.539 550.159 268.691 549.38 268.691ZM554.772 262.907C554.772 261.802 555.021 260.811 555.519 259.934C556.017 259.046 556.694 258.353 557.55 257.855C558.416 257.356 559.375 257.107 560.425 257.107C561.66 257.107 562.738 257.405 563.658 258.001C564.579 258.597 565.25 259.441 565.673 260.535H563.902C563.588 259.853 563.133 259.328 562.537 258.959C561.952 258.591 561.248 258.407 560.425 258.407C559.635 258.407 558.925 258.591 558.297 258.959C557.669 259.328 557.176 259.853 556.819 260.535C556.461 261.207 556.283 261.997 556.283 262.907C556.283 263.806 556.461 264.597 556.819 265.279C557.176 265.95 557.669 266.47 558.297 266.839C558.925 267.207 559.635 267.391 560.425 267.391C561.248 267.391 561.952 267.212 562.537 266.855C563.133 266.487 563.588 265.961 563.902 265.279H565.673C565.25 266.362 564.579 267.201 563.658 267.797C562.738 268.382 561.66 268.674 560.425 268.674C559.375 268.674 558.416 268.431 557.55 267.943C556.694 267.445 556.017 266.757 555.519 265.88C555.021 265.003 554.772 264.012 554.772 262.907ZM569.352 267.375H573.316V268.577H567.873V257.254H569.352V267.375Z"
              fill="#686868"
            />
          </g>
          <g id="AXR">
            <g
              id="Rectangle 42"
              filter="url(#filter10_d_OtherOrganMetastasesImage)"
            >
              <rect
                x={360.632}
                y={351.788}
                width={48.5096}
                height={49.4772}
                rx={5.75168}
                fill="white"
              />
            </g>
            <path
              id="AXR_2"
              d="M376.139 379.482H371.2L370.29 382H368.73L372.824 370.742H374.53L378.608 382H377.048L376.139 379.482ZM375.716 378.28L373.669 372.562L371.622 378.28H375.716ZM385.022 376.347L388.499 382H386.825L384.112 377.582L381.529 382H379.888L383.349 376.347L379.872 370.677H381.529L384.259 375.112L386.858 370.677H388.515L385.022 376.347ZM396.444 382L393.748 377.37H391.961V382H390.482V370.677H394.137C394.993 370.677 395.713 370.823 396.298 371.116C396.894 371.408 397.338 371.804 397.63 372.302C397.923 372.8 398.069 373.369 398.069 374.008C398.069 374.787 397.842 375.475 397.387 376.071C396.943 376.666 396.271 377.062 395.372 377.257L398.215 382H396.444ZM391.961 376.184H394.137C394.939 376.184 395.54 375.99 395.941 375.6C396.341 375.199 396.542 374.668 396.542 374.008C396.542 373.336 396.341 372.816 395.941 372.448C395.551 372.08 394.95 371.896 394.137 371.896H391.961V376.184Z"
              fill="#686868"
            />
          </g>
          <g id="AXL">
            <g
              id="Rectangle 43"
              filter="url(#filter11_d_OtherOrganMetastasesImage)"
            >
              <rect
                width={49.4079}
                height={49.4772}
                rx={5.75168}
                transform="matrix(-1 0 0 1 663.368 351.788)"
                fill="white"
              />
            </g>
            <path
              id="AXL_2"
              d="M631.372 379.482H626.434L625.524 382H623.964L628.058 370.742H629.764L633.842 382H632.282L631.372 379.482ZM630.95 378.28L628.903 372.562L626.856 378.28H630.95ZM640.256 376.347L643.732 382H642.059L639.346 377.582L636.763 382H635.122L638.583 376.347L635.106 370.677H636.763L639.492 375.112L642.092 370.677H643.749L640.256 376.347ZM647.194 380.798H651.158V382H645.716V370.677H647.194V380.798Z"
              fill="#686868"
            />
          </g>
          <g id="Liver" filter="url(#filter12_d_OtherOrganMetastasesImage)">
            <path
              d="M580.639 457.668C582.307 458.326 583.531 459.786 583.891 461.549C584.254 463.311 583.7 465.137 582.426 466.402C576.174 472.464 563.306 481.872 539.388 488.468C526.449 492.036 508.514 500.461 482.579 520.168C460.344 537.065 431.505 546.944 426.725 530.78C406.069 460.942 434.453 434.425 491.911 437.195C511.904 438.159 559.863 449.632 580.639 457.668Z"
              fill="white"
            />
          </g>
          <g id="RP">
            <g
              id="Rectangle 44"
              filter="url(#filter13_d_OtherOrganMetastasesImage)"
            >
              <rect
                width={49.4079}
                height={51.9502}
                rx={5.75168}
                transform="matrix(-1 0 0 1 536.704 544)"
                fill="white"
              />
            </g>
            <path
              id="RP_2"
              d="M509.567 574L506.87 569.37H505.083V574H503.605V562.677H507.26C508.116 562.677 508.836 562.823 509.421 563.115C510.017 563.408 510.461 563.803 510.753 564.301C511.046 564.799 511.192 565.368 511.192 566.007C511.192 566.787 510.964 567.475 510.509 568.07C510.065 568.666 509.394 569.061 508.495 569.256L511.338 574H509.567ZM505.083 568.184H507.26C508.062 568.184 508.663 567.989 509.064 567.599C509.464 567.198 509.665 566.668 509.665 566.007C509.665 565.336 509.464 564.816 509.064 564.447C508.674 564.079 508.073 563.895 507.26 563.895H505.083V568.184ZM521.059 565.991C521.059 566.933 520.734 567.718 520.085 568.346C519.446 568.964 518.466 569.272 517.144 569.272H514.967V574H513.489V562.677H517.144C518.422 562.677 519.392 562.985 520.052 563.603C520.724 564.22 521.059 565.016 521.059 565.991ZM517.144 568.054C517.967 568.054 518.574 567.875 518.964 567.518C519.354 567.161 519.549 566.651 519.549 565.991C519.549 564.594 518.747 563.895 517.144 563.895H514.967V568.054H517.144Z"
              fill="#686868"
            />
          </g>
          <g id="Group 83">
            <g
              id="Lung-Right"
              filter="url(#filter14_d_OtherOrganMetastasesImage)"
            >
              <path
                d="M448.116 433.432C403.81 457.871 400.281 410.726 421.88 347.866C427.412 331.768 454.728 284.973 482.376 295.536C486.42 297.082 487 302.142 487 306.472V415.308C487 422.672 481.51 430.64 474.174 429.988C466.168 429.276 457.11 428.47 448.116 433.432Z"
                fill="white"
              />
            </g>
            <g
              id="Lung-Left"
              filter="url(#filter15_d_OtherOrganMetastasesImage)"
            >
              <path
                d="M575.386 433.432C619.123 457.871 622.607 410.726 601.285 347.866C595.824 331.768 568.858 284.973 541.565 295.536C537.554 297.089 537 302.127 537 306.428V415.47C537 422.745 542.415 430.64 549.661 429.988C557.565 429.276 566.506 428.47 575.386 433.432Z"
                fill="white"
              />
            </g>
          </g>
          <g id="MED/HIL">
            <g
              id="Rectangle 45"
              filter="url(#filter16_d_OtherOrganMetastasesImage)"
            >
              <rect
                width={49.4079}
                height={65.7457}
                rx={5.75168}
                transform="matrix(-1 0 0 1 536.704 333.02)"
                fill="white"
              />
            </g>
            <path
              id="MED HIL"
              d="M506.95 348.88V360.122H505.471V351.739L501.735 360.122H500.695L496.942 351.723V360.122H495.464V348.88H497.056L501.215 358.172L505.374 348.88H506.95ZM510.935 350.001V353.786H515.062V355.004H510.935V358.903H515.549V360.122H509.457V348.782H515.549V350.001H510.935ZM521.311 348.798C522.546 348.798 523.613 349.031 524.512 349.497C525.421 349.952 526.115 350.607 526.591 351.463C527.079 352.318 527.322 353.325 527.322 354.484C527.322 355.643 527.079 356.65 526.591 357.506C526.115 358.351 525.421 359.001 524.512 359.456C523.613 359.9 522.546 360.122 521.311 360.122H517.786V348.798H521.311ZM521.311 358.903C522.773 358.903 523.889 358.519 524.658 357.75C525.427 356.97 525.811 355.881 525.811 354.484C525.811 353.076 525.421 351.977 524.642 351.186C523.873 350.396 522.763 350.001 521.311 350.001H519.264V358.903H521.311ZM509.963 372.798V384.122H508.484V378.988H502.717V384.122H501.239V372.798H502.717V377.77H508.484V372.798H509.963ZM513.965 372.798V384.122H512.487V372.798H513.965ZM517.963 382.919H521.927V384.122H516.485V372.798H517.963V382.919Z"
              fill="#686868"
            />
          </g>
          <g id="CIR">
            <g
              id="Rectangle 45_2"
              filter="url(#filter17_d_OtherOrganMetastasesImage)"
            >
              <rect
                width={62.7973}
                height={34.1655}
                rx={5.75168}
                transform="matrix(-0.707107 0.707107 0.707107 0.707107 482.582 601)"
                fill="white"
              />
            </g>
            <path
              id="CIR_2"
              d="M462.799 644.91C462.018 644.129 461.493 643.252 461.225 642.279C460.95 641.299 460.938 640.33 461.191 639.373C461.451 638.408 461.953 637.554 462.696 636.811C463.569 635.938 464.541 635.387 465.613 635.157C466.686 634.927 467.758 635.05 468.83 635.525L467.578 636.777C466.873 636.516 466.18 636.466 465.499 636.627C464.825 636.78 464.197 637.148 463.615 637.73C463.056 638.289 462.684 638.921 462.5 639.626C462.317 640.33 462.34 641.05 462.569 641.785C462.791 642.513 463.224 643.198 463.867 643.841C464.503 644.477 465.188 644.91 465.924 645.14C466.651 645.362 467.367 645.381 468.072 645.197C468.776 645.013 469.408 644.642 469.967 644.083C470.549 643.501 470.921 642.876 471.081 642.21C471.242 641.529 471.193 640.836 470.932 640.131L472.184 638.879C472.651 639.943 472.77 641.012 472.54 642.084C472.303 643.148 471.748 644.117 470.875 644.99C470.132 645.733 469.282 646.238 468.325 646.507C467.367 646.759 466.402 646.752 465.43 646.484C464.457 646.216 463.58 645.691 462.799 644.91ZM469.111 630.603L477.118 638.609L476.072 639.655L468.066 631.648L469.111 630.603ZM483.115 632.612L477.934 631.245L476.671 632.508L479.945 635.782L478.899 636.828L470.893 628.821L473.477 626.236C474.082 625.631 474.695 625.225 475.315 625.019C475.943 624.804 476.537 624.77 477.096 624.915C477.655 625.061 478.16 625.359 478.612 625.811C479.164 626.363 479.489 627.01 479.589 627.753C479.696 628.488 479.501 629.242 479.003 630.016L484.367 631.36L483.115 632.612ZM475.832 631.67L477.372 630.131C477.938 629.564 478.225 629.001 478.233 628.442C478.233 627.875 477.999 627.358 477.532 626.891C477.058 626.416 476.548 626.19 476.004 626.213C475.468 626.229 474.913 626.523 474.339 627.098L472.799 628.637L475.832 631.67Z"
              fill="#686868"
            />
          </g>
          <g id="IR">
            <g
              id="Rectangle 45_3"
              filter="url(#filter18_d_OtherOrganMetastasesImage)"
            >
              <rect
                width={49.6606}
                height={37.867}
                rx={5.75168}
                transform="matrix(-1 0 0 1 481.495 675)"
                fill="white"
              />
            </g>
            <path
              id="IR_2"
              d="M451.566 688.919V700.242H450.087V688.919H451.566ZM460.047 700.242L457.351 695.612H455.564V700.242H454.085V688.919H457.741C458.596 688.919 459.316 689.065 459.901 689.358C460.497 689.65 460.941 690.045 461.233 690.544C461.526 691.042 461.672 691.61 461.672 692.249C461.672 693.029 461.445 693.717 460.99 694.313C460.546 694.908 459.874 695.304 458.975 695.499L461.818 700.242H460.047ZM455.564 694.426H457.741C458.542 694.426 459.143 694.231 459.544 693.842C459.945 693.441 460.145 692.91 460.145 692.249C460.145 691.578 459.945 691.058 459.544 690.69C459.154 690.322 458.553 690.138 457.741 690.138H455.564V694.426Z"
              fill="#686868"
            />
          </g>
          <g id="IL">
            <g
              id="Rectangle 45_4"
              filter="url(#filter19_d_OtherOrganMetastasesImage)"
            >
              <rect
                width={49.6606}
                height={37.867}
                rx={5.75168}
                transform="matrix(-1 0 0 1 594.624 675)"
                fill="white"
              />
            </g>
            <path
              id="IL_2"
              d="M566.131 688.919V700.242H564.652V688.919H566.131ZM570.129 699.04H574.092V700.242H568.65V688.919H570.129V699.04Z"
              fill="#686868"
            />
          </g>
          <g id="CIL">
            <g
              id="Rectangle 45_5"
              filter="url(#filter20_d_OtherOrganMetastasesImage)"
            >
              <rect
                width={62.7973}
                height={34.1655}
                rx={5.75168}
                transform="matrix(-0.707107 -0.707107 -0.707107 0.707107 585.828 645.404)"
                fill="white"
              />
            </g>
            <path
              id="CIL_2"
              d="M542.933 626.636C543.714 625.855 544.591 625.331 545.563 625.063C546.543 624.787 547.512 624.775 548.47 625.028C549.434 625.288 550.288 625.79 551.031 626.533C551.904 627.406 552.456 628.379 552.685 629.451C552.915 630.523 552.793 631.595 552.318 632.667L551.066 631.415C551.326 630.711 551.376 630.017 551.215 629.336C551.062 628.662 550.694 628.034 550.112 627.452C549.553 626.893 548.921 626.521 548.217 626.338C547.512 626.154 546.792 626.177 546.057 626.407C545.33 626.629 544.644 627.061 544.001 627.705C543.365 628.34 542.933 629.026 542.703 629.761C542.481 630.488 542.462 631.205 542.645 631.909C542.829 632.614 543.201 633.245 543.76 633.805C544.342 634.387 544.966 634.758 545.632 634.919C546.314 635.08 547.007 635.03 547.711 634.769L548.964 636.022C547.899 636.489 546.831 636.607 545.759 636.378C544.694 636.14 543.725 635.585 542.852 634.712C542.109 633.969 541.604 633.119 541.336 632.162C541.083 631.205 541.091 630.24 541.359 629.267C541.627 628.294 542.151 627.417 542.933 626.636ZM557.24 632.948L549.233 640.955L548.188 639.91L556.194 631.903L557.24 632.948ZM552.91 642.932L555.713 645.735L554.863 646.585L551.015 642.737L559.021 634.73L560.067 635.775L552.91 642.932Z"
              fill="#686868"
            />
          </g>
          <g id="RC">
            <g
              id="Rectangle 46"
              filter="url(#filter21_d_OtherOrganMetastasesImage)"
            >
              <rect
                width={49.4079}
                height={47.678}
                rx={5.75168}
                transform="matrix(-1 0 0 1 536.704 417)"
                fill="white"
              />
            </g>
            <path
              id="RC_2"
              d="M508.395 446.471L505.698 441.841H503.911V446.471H502.433V435.148H506.088C506.944 435.148 507.664 435.294 508.249 435.587C508.844 435.879 509.288 436.275 509.581 436.773C509.873 437.271 510.019 437.84 510.019 438.479C510.019 439.258 509.792 439.946 509.337 440.542C508.893 441.137 508.222 441.533 507.323 441.728L510.166 446.471H508.395ZM503.911 440.655H506.088C506.889 440.655 507.49 440.461 507.891 440.071C508.292 439.67 508.492 439.139 508.492 438.479C508.492 437.807 508.292 437.287 507.891 436.919C507.501 436.551 506.9 436.367 506.088 436.367H503.911V440.655ZM511.764 440.802C511.764 439.697 512.013 438.706 512.511 437.829C513.01 436.941 513.687 436.247 514.542 435.749C515.409 435.251 516.367 435.002 517.418 435.002C518.652 435.002 519.73 435.3 520.651 435.895C521.571 436.491 522.243 437.336 522.665 438.43H520.894C520.58 437.748 520.125 437.222 519.53 436.854C518.945 436.486 518.241 436.302 517.418 436.302C516.627 436.302 515.918 436.486 515.289 436.854C514.661 437.222 514.168 437.748 513.811 438.43C513.454 439.101 513.275 439.892 513.275 440.802C513.275 441.701 513.454 442.491 513.811 443.174C514.168 443.845 514.661 444.365 515.289 444.733C515.918 445.101 516.627 445.286 517.418 445.286C518.241 445.286 518.945 445.107 519.53 444.749C520.125 444.381 520.58 443.856 520.894 443.174H522.665C522.243 444.257 521.571 445.096 520.651 445.692C519.73 446.276 518.652 446.569 517.418 446.569C516.367 446.569 515.409 446.325 514.542 445.838C513.687 445.34 513.01 444.652 512.511 443.775C512.013 442.897 511.764 441.906 511.764 440.802Z"
              fill="#686868"
            />
          </g>
          <g
            id="Brain-Right"
            filter="url(#filter22_d_OtherOrganMetastasesImage)"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M509.032 54.8728C509.809 54.8243 510.571 55.1001 511.134 55.6284C511.697 56.1531 512.01 56.8903 511.996 57.6529L512.182 157.208C512.183 157.682 512.137 158.157 511.989 158.607C511.648 159.648 510.823 161.451 508.206 161.574C480.489 162.867 465.766 173.697 458.182 108.669C457.644 80.2192 480.401 56.7024 509.032 54.8728Z"
              fill="white"
            />
          </g>
          <g
            id="Brain-Left"
            filter="url(#filter23_d_OtherOrganMetastasesImage)"
          >
            <path
              d="M512 158.576C512.004 158.586 512.007 158.597 512.01 158.607C512.352 159.648 513.177 161.451 515.794 161.574C519.269 161.736 522.54 162.048 525.618 162.341C547.091 164.39 559.185 165.544 565.818 108.669C566.356 80.2192 543.599 56.7024 514.968 54.8728C514.191 54.8243 513.428 55.1001 512.865 55.6284C512.303 56.1531 511.99 56.8903 512.004 57.6529L512 59.4137V158.576Z"
              fill="#FCFCFC"
            />
          </g>
        </g>
      </g>
      <g id="Metastases">
        {Object.keys(metastases).map((key) => (
          <circle
            key={key}
            id={key}
            cx={(metastases[key] as Coordinates).x}
            cy={(metastases[key] as Coordinates).y}
            r={15}
            fill={(metastases[key] as Coordinates).color || markerColor}
            fillOpacity={0.5}
            onClick={onMetastasisClick}
            onContextMenu={onContextMenu}
          />
        ))}
      </g>
      <defs>
        <filter
          id="filter0_f_OtherOrganMetastasesImage"
          x={355.492}
          y={98}
          width={313.016}
          height={623.799}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={5}
            result="effect1_foregroundBlur_OtherOrganMetastasesImage"
          />
        </filter>
        <filter
          id="filter1_f_OtherOrganMetastasesImage"
          x={386.988}
          y={555.709}
          width={249.398}
          height={218.385}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={3.04655}
            result="effect1_foregroundBlur_OtherOrganMetastasesImage"
          />
        </filter>
        <filter
          id="filter2_f_OtherOrganMetastasesImage"
          x={413.323}
          y={482.272}
          width={196.728}
          height={291.857}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={3.24965}
            result="effect1_foregroundBlur_OtherOrganMetastasesImage"
          />
        </filter>
        <filter
          id="filter3_f_OtherOrganMetastasesImage"
          x={253.216}
          y={33.2156}
          width={517.569}
          height={745.569}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={5.3922}
            result="effect1_foregroundBlur_OtherOrganMetastasesImage"
          />
        </filter>
        <filter
          id="filter4_f_OtherOrganMetastasesImage"
          x={545}
          y={536.051}
          width={55.6262}
          height={79.9489}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={4}
            result="effect1_foregroundBlur_OtherOrganMetastasesImage"
          />
        </filter>
        <filter
          id="filter5_f_OtherOrganMetastasesImage"
          x={423.415}
          y={536.051}
          width={55.6262}
          height={79.9489}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation={4}
            result="effect1_foregroundBlur_OtherOrganMetastasesImage"
          />
        </filter>
        <filter
          id="filter6_d_OtherOrganMetastasesImage"
          x={425.838}
          y={162.012}
          width={110.34}
          height={111.308}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2.87584} />
          <feGaussianBlur stdDeviation={15.4576} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_OtherOrganMetastasesImage"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_OtherOrganMetastasesImage"
            result="shape"
          />
        </filter>
        <filter
          id="filter7_d_OtherOrganMetastasesImage"
          x={486.923}
          y={162.012}
          width={111.238}
          height={111.308}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2.87584} />
          <feGaussianBlur stdDeviation={15.4576} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_OtherOrganMetastasesImage"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_OtherOrganMetastasesImage"
            result="shape"
          />
        </filter>
        <filter
          id="filter8_d_OtherOrganMetastasesImage"
          x={408.32}
          y={211.491}
          width={111.238}
          height={110.408}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2.87584} />
          <feGaussianBlur stdDeviation={15.4576} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_OtherOrganMetastasesImage"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_OtherOrganMetastasesImage"
            result="shape"
          />
        </filter>
        <filter
          id="filter9_d_OtherOrganMetastasesImage"
          x={504.441}
          y={211.49}
          width={111.238}
          height={110.408}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2.87584} />
          <feGaussianBlur stdDeviation={15.4576} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_OtherOrganMetastasesImage"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_OtherOrganMetastasesImage"
            result="shape"
          />
        </filter>
        <filter
          id="filter10_d_OtherOrganMetastasesImage"
          x={329.717}
          y={323.748}
          width={110.34}
          height={111.308}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2.87584} />
          <feGaussianBlur stdDeviation={15.4576} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_OtherOrganMetastasesImage"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_OtherOrganMetastasesImage"
            result="shape"
          />
        </filter>
        <filter
          id="filter11_d_OtherOrganMetastasesImage"
          x={583.044}
          y={323.748}
          width={111.238}
          height={111.308}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2.87584} />
          <feGaussianBlur stdDeviation={15.4576} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_OtherOrganMetastasesImage"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_OtherOrganMetastasesImage"
            result="shape"
          />
        </filter>
        <filter
          id="filter12_d_OtherOrganMetastasesImage"
          x={389.085}
          y={408.961}
          width={225.831}
          height={163.831}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2.87584} />
          <feGaussianBlur stdDeviation={15.4576} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_OtherOrganMetastasesImage"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_OtherOrganMetastasesImage"
            result="shape"
          />
        </filter>
        <filter
          id="filter13_d_OtherOrganMetastasesImage"
          x={456.381}
          y={515.961}
          width={111.238}
          height={113.781}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2.87584} />
          <feGaussianBlur stdDeviation={15.4576} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_OtherOrganMetastasesImage"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_OtherOrganMetastasesImage"
            result="shape"
          />
        </filter>
        <filter
          id="filter14_d_OtherOrganMetastasesImage"
          x={378.085}
          y={265.961}
          width={139.831}
          height={207.831}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2.87584} />
          <feGaussianBlur stdDeviation={15.4576} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_OtherOrganMetastasesImage"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_OtherOrganMetastasesImage"
            result="shape"
          />
        </filter>
        <filter
          id="filter15_d_OtherOrganMetastasesImage"
          x={506.085}
          y={265.961}
          width={138.831}
          height={207.831}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2.87584} />
          <feGaussianBlur stdDeviation={15.4576} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_OtherOrganMetastasesImage"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_OtherOrganMetastasesImage"
            result="shape"
          />
        </filter>
        <filter
          id="filter16_d_OtherOrganMetastasesImage"
          x={456.381}
          y={304.98}
          width={111.238}
          height={127.576}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2.87584} />
          <feGaussianBlur stdDeviation={15.4576} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_OtherOrganMetastasesImage"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_OtherOrganMetastasesImage"
            result="shape"
          />
        </filter>
        <filter
          id="filter17_d_OtherOrganMetastasesImage"
          x={409.645}
          y={575.343}
          width={125.629}
          height={125.629}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2.87584} />
          <feGaussianBlur stdDeviation={15.4576} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_OtherOrganMetastasesImage"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_OtherOrganMetastasesImage"
            result="shape"
          />
        </filter>
        <filter
          id="filter18_d_OtherOrganMetastasesImage"
          x={400.919}
          y={646.961}
          width={111.491}
          height={99.6975}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2.87584} />
          <feGaussianBlur stdDeviation={15.4576} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_OtherOrganMetastasesImage"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_OtherOrganMetastasesImage"
            result="shape"
          />
        </filter>
        <filter
          id="filter19_d_OtherOrganMetastasesImage"
          x={514.048}
          y={646.961}
          width={111.491}
          height={99.6975}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2.87584} />
          <feGaussianBlur stdDeviation={15.4576} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_OtherOrganMetastasesImage"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_OtherOrganMetastasesImage"
            result="shape"
          />
        </filter>
        <filter
          id="filter20_d_OtherOrganMetastasesImage"
          x={488.732}
          y={575.343}
          width={125.629}
          height={125.629}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2.87584} />
          <feGaussianBlur stdDeviation={15.4576} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_OtherOrganMetastasesImage"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_OtherOrganMetastasesImage"
            result="shape"
          />
        </filter>
        <filter
          id="filter21_d_OtherOrganMetastasesImage"
          x={456.381}
          y={388.961}
          width={111.238}
          height={109.509}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2.87584} />
          <feGaussianBlur stdDeviation={15.4576} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_OtherOrganMetastasesImage"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_OtherOrganMetastasesImage"
            result="shape"
          />
        </filter>
        <filter
          id="filter22_d_OtherOrganMetastasesImage"
          x={427.258}
          y={26.8279}
          width={115.84}
          height={169.992}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2.87584} />
          <feGaussianBlur stdDeviation={15.4576} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_OtherOrganMetastasesImage"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_OtherOrganMetastasesImage"
            result="shape"
          />
        </filter>
        <filter
          id="filter23_d_OtherOrganMetastasesImage"
          x={481.085}
          y={26.8279}
          width={115.657}
          height={169.992}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy={2.87584} />
          <feGaussianBlur stdDeviation={15.4576} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.18 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_OtherOrganMetastasesImage"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_OtherOrganMetastasesImage"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_OtherOrganMetastasesImage"
          x1={425.153}
          y1={631.966}
          x2={425.153}
          y2={768}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.1875} stopColor="#B1B1B1" />
          <stop offset={0.869792} stopColor="#B1B1B1" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint1_linear_OtherOrganMetastasesImage"
          x1={598.584}
          y1={631.966}
          x2={598.584}
          y2={768}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.1875} stopColor="#B1B1B1" />
          <stop offset={0.869792} stopColor="#B1B1B1" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="paint2_linear_OtherOrganMetastasesImage"
          x1={511.687}
          y1={488.772}
          x2={511.687}
          y2={767.63}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.682292} stopColor="#B1B1B1" />
          <stop offset={0.869792} stopColor="#B1B1B1" stopOpacity={0} />
        </linearGradient>
        <radialGradient
          id="paint3_radial_OtherOrganMetastasesImage"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(511.626 -7.26833) rotate(90) scale(826.115 246.814)"
        >
          <stop stopColor="#F6F6F6" />
          <stop offset={0.364583} stopColor="#BBBBBB" stopOpacity={0.760417} />
          <stop offset={0.989583} stopOpacity={0} />
        </radialGradient>
        <linearGradient
          id="paint4_linear_OtherOrganMetastasesImage"
          x1={512}
          y1={44}
          x2={512}
          y2={767.655}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.982946} stopColor="white" stopOpacity={0} />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <radialGradient
          id="paint5_radial_OtherOrganMetastasesImage"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(511.626 -7.26833) rotate(90) scale(826.115 246.814)"
        >
          <stop stopColor="#F6F6F6" />
          <stop offset={0.364583} stopColor="#BBBBBB" stopOpacity={0.760417} />
          <stop offset={0.989583} stopOpacity={0} />
        </radialGradient>
        <linearGradient
          id="paint6_linear_OtherOrganMetastasesImage"
          x1={512}
          y1={44}
          x2={512}
          y2={767.655}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.982946} stopColor="white" stopOpacity={0} />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <radialGradient
          id="paint7_radial_OtherOrganMetastasesImage"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(511.626 -7.26833) rotate(90) scale(826.115 246.814)"
        >
          <stop stopColor="#F6F6F6" />
          <stop offset={0.364583} stopColor="#BBBBBB" stopOpacity={0.760417} />
          <stop offset={0.989583} stopOpacity={0} />
        </radialGradient>
        <linearGradient
          id="paint8_linear_OtherOrganMetastasesImage"
          x1={512}
          y1={44}
          x2={512}
          y2={767.655}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.982946} stopColor="white" stopOpacity={0} />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <radialGradient
          id="paint9_radial_OtherOrganMetastasesImage"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(511.626 -7.26833) rotate(90) scale(826.115 246.814)"
        >
          <stop stopColor="#F6F6F6" />
          <stop offset={0.364583} stopColor="#BBBBBB" stopOpacity={0.760417} />
          <stop offset={0.989583} stopOpacity={0} />
        </radialGradient>
        <linearGradient
          id="paint10_linear_OtherOrganMetastasesImage"
          x1={512}
          y1={44}
          x2={512}
          y2={767.655}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.982946} stopColor="white" stopOpacity={0} />
          <stop offset={1} stopColor="white" />
        </linearGradient>
        <clipPath id="clip0_OtherOrganMetastasesImage">
          <rect width={1024} height={768} fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
);

export default OtherOrganMetastasesImage;
